import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface DeleteMembershipIncomeParams {
    id: string;
}

const useDeleteMembershipIncome = requestBuilder.mutation<
    GeneralResponse,
    null,
    DeleteMembershipIncomeParams
>({
    endpoint: ({ id }) => `/api/membership-income/${id}`,
    method: 'DELETE',
});

export default useDeleteMembershipIncome;
